/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext } from "react";
import AppContext from "../../../../Store/AppContext";
import {
  Listar as ListarTipoDocs,
  Detalhes as DetalhesTipoDocs,
  Remover as RemoverTipoDocs,
  Incluir as IncluirTipoDocs,
  Atualizar as AtualizarTipoDocs,
} from "../../../../Services/TipoDocs";
import { useHistory } from "react-router-dom";
import { validarPermissoesPagina } from "../../../../Utils/validarPermissoesPagina";
export const TipoDocsContext = createContext();

const tituloTela = "Tipos de Documentos";

const defaultData = {
  tipoDocsId: 0,
  tipoDocsNome: "",
  tipoDocsStatus: "",
  subTipoDocsList: [],              // NEW
};

const searchData = {
  tipoDocsNome: "",
};

const columnsDefinition = [
  { text: "Id", dataField: "tipoDocsId", hidden: true },
  { text: "Descrição", dataField: "tipoDocsNome", headerStyle: { width: "450px" }, sort: true },
  {
    text: "Status",
    dataField: "tipoDocsStatus",
    headerStyle: { width: "80px" },
    sort: true,
    formatter: (cell) =>
      cell === "A"
        ? <span className="badge badge-success">Ativo</span>
        : <span className="badge badge-danger">Inativo</span>, // fix “Inátivo”
  },
];

function initialState() {
  return {
    searchData: searchData,
    resultSearch: [],
    columnsDefinition: columnsDefinition,
    data: defaultData,
    formDisabled: true,
  };
}

const TipoDocsProvider = ({ children }) => {
  const { showLoading, hideLoading, showMessage, setTituloTela } = useContext(AppContext);
  const [values, setValues] = useState(initialState());
  let history = useHistory();

  async function loadDependences() {
    const permissoesPagina = validarPermissoesPagina();
    return { permissoesPagina };
  }

  const resetScreen = () => {
    showLoading();
    async function carregarDependencias() {
      const dependencias = await loadDependences();
      setTituloTela(tituloTela);
      setValues({
        ...initialState(),
        permissoesPagina: await dependencias.permissoesPagina,
      });
      hideLoading();
    }
    carregarDependencias();
  };

  const searchHandler = async () => {
    showLoading();
    const responseListarTipoDocs = await ListarTipoDocs(values.searchData);

    if (!responseListarTipoDocs.success) {
      showMessage("Erro", "Erro Inesperado durante a pesquisa.");
      hideLoading();
      return;
    }

    const resultSearchData = await responseListarTipoDocs.tiposDocs;
    resultSearchData.map((data) => (data.Id = data.tipoDocsId));
    setValues({ ...values, resultSearch: resultSearchData });

    if (resultSearchData.length === 0) showMessage("Alerta", "Nenhum registro encontrado.");
    hideLoading();
  };

  const removeHandler = async (id) => {
    showLoading();
    const responseRemover = await RemoverTipoDocs(id);

    if (!responseRemover.success) {
      hideLoading();
      showMessage("Erro", `Erro durante a exclusão: ${responseRemover.message}`);
      return;
    }
    searchHandler();
    hideLoading();
    showMessage("Sucesso", "Registro excluido.");
  };

  const getDetailHandler = async (id) => {
    showLoading();
    const dependencias = await loadDependences();

    if (id > 0) {
      const responseDetalhes = await DetalhesTipoDocs(id);
      const { success, tipoDocs } = await responseDetalhes;

      if (!success) {
        showMessage("Erro", "Erro ao buscar os detalhes do registro.");
        setValues({
          ...values,
          data: defaultData,
          permissoesPagina: await dependencias.permissoesPagina,
        });
      }

      let subTipoDocsList = Array.isArray(tipoDocs?.subTipoDocsList) ? tipoDocs.subTipoDocsList : [];

      subTipoDocsList.map((subTipoDoc) => {
        subTipoDoc.id = subTipoDoc.subTipoDocsId;
        subTipoDoc.tipoDocsNome = subTipoDocsList.find(
          (supervisor) => supervisor.subTipoDocsId === subTipoDoc.subTipoDocsId
        ).tipoDocsNome;
        return subTipoDoc;
      });

      setValues({
        ...values,
        data: {
          ...tipoDocs,
          subTipoDocsList: subTipoDocsList
        },
        permissoesPagina: await dependencias.permissoesPagina,
      });
    } else {
      setValues({
        ...values,
        data: { ...defaultData, tipoDocsId: 0, subTipoDocsList: [] }, // NEW
        permissoesPagina: await dependencias.permissoesPagina,
        formDisabled: false,
      });
    }
    hideLoading();
  };

  const createData = async () => {
    showLoading();
    const responseIncluir = await IncluirTipoDocs(values.data);
    if (!responseIncluir.success) {
      hideLoading();
      showMessage("Erro", `Erro ao criar o registro: ${responseIncluir.message}`);
      responseIncluir.errors.map((erro) => showMessage("Erro", erro.errorMessage));
      return;
    }
    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro criado.");
    history.goBack();
  };

  const editHandler = () => setValues({ ...values, formDisabled: false });

  const updateData = async () => {
    showLoading();
    const responseAtualizar = await AtualizarTipoDocs(values.data);
    if (!responseAtualizar.success) {
      hideLoading();
      showMessage("Erro", `Erro ao atualizar o registro: ${responseAtualizar.message}`);
      return;
    }
    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro atualizado.");
    history.goBack();
  };

  const saveHandler = async () => {
    if (values.data.tipoDocsId === 0) await createData();
    else await updateData();
  };

  const cancelHandler = () => setValues({ ...values, data: defaultData, formDisabled: true });

  return (
    <TipoDocsContext.Provider
      value={{
        values,
        setValues,
        resetScreen,
        searchHandler,
        cancelHandler,
        removeHandler,
        saveHandler,
        editHandler,
        getDetailHandler
      }}
    >
      {children}
    </TipoDocsContext.Provider>
  );
};

export default TipoDocsProvider;
